"use client";
import Link from "next/link";
import Icon from "@/components/icons";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import useIsMobile from "@/hooks/useIsMobile";

interface PromoBannerTooltipProps {
  discountCode: string;
  endDate: string;
  learnMoreLink?: string;
}

export default function PromoBannerTooltip({
  discountCode,
  endDate,
  learnMoreLink,
}: PromoBannerTooltipProps) {
  const isMobile = useIsMobile();
  return (
    <Popover>
      <PopoverTrigger>
        <div className="text-primary-foreground">
          <Icon type="info" />
        </div>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        side={isMobile ? "bottom" : "right"}
        className="bg-primary text-primary-foreground rounded-xl"
      >
        Offer is valid until {endDate}, at 11:59 p.m. Eastern Time (U.S.). Offer
        does not apply to degree programs. Offer cannot be combined with other
        discount codes. To redeem the offer for verified courses, Professional
        Certificates, XSeries, MicroBachelors® Programs, and MicroMasters®
        Programs, use code {discountCode} at checkout on{" "}
        <Link href="/" className="underline">
          edX.org
        </Link>
        .
        {learnMoreLink && (
          <span>
            {" "}
            <a href={learnMoreLink} className="underline">
              Learn more.
            </a>
          </span>
        )}
      </PopoverContent>
    </Popover>
  );
}
